import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatDialogCloseEvent } from '../../../const';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TicketManagementService } from '../ticket-management.service';
import { ToastrService } from 'ngx-toastr';
interface TicketStatusCategory {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-add-ticket-comments',
  templateUrl: './add-ticket-comments.component.html'
})
export class AddTicketCommentsComponent {

  ticketId: number = 0;
  TicketUpdateForm: FormGroup;

  constructor( public dialog: MatDialog, 
    @Optional() public dialogRef: MatDialogRef<AddTicketCommentsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder, 
    private ticketManagementService: TicketManagementService,
    private toasterService: ToastrService) { 
      
      this.TicketUpdateForm = this.fb.group(
        {
          TicketStatus: ['', [Validators.required]],
          Comment: ['', [Validators.required, Validators.maxLength(300)]]
        });
    }


    ticketStatusCategory: TicketStatusCategory[] = [
      {value: 'New', viewValue: 'New'},
      {value: 'InProgress', viewValue: 'InProgress'},
      {value: 'OnHold', viewValue: 'OnHold'},
      {value: 'Closed', viewValue: 'Closed'}
        ];

  ngOnInit(): void {
    this.ticketId = this.data.ticketId;
  }

  cancel(){
    this.dialogRef.close({event: MatDialogCloseEvent.CANCELLED});
  }

  onSubmit(): void {
    if (this.TicketUpdateForm.valid) {
      const formData = {
        ...this.TicketUpdateForm.value,
        ticketId: this.ticketId
      };

      this.ticketManagementService.updateTicketStatus(formData).subscribe({
        next: (response) => {
          this.toasterService.success('Ticket Updated successfully!', 'Success');
          this.dialogRef.close({ event: MatDialogCloseEvent.SUCCESS, data: formData });
        },
        error: (error) => {
          console.error('Error creating ticket', error);
          this.toasterService.error(error, 'Error')
        }
      });
    }
  }
}
